// extracted by mini-css-extract-plugin
module.exports = {"fontGotham":"button_fontGotham__3mCyT","button":"button_button__1AE27","content":"button_content__28zKn","icon":"button_icon__3S0MK"};